var render = function render(){var _vm=this,_c=_vm._self._c;return _c('badge',{attrs:{"type":_vm.badgeType}},[_vm._v(" "+_vm._s(_vm.$t("PAYMENT_METHODS." + _vm.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }